StageRenderer 	= require "core/StageRenderer"
Signal 			= require "signals"

class MainNavigation 
	
	@onChapClick 	= new Signal()

	constructor:()->
		#TODO: add pre-defined value for clear syntax loading of textures
		console.log('MainNavigation.constructor')
		@init()
		return

	@init:()->
		console.log('MainNavigation.init')
		StageRenderer.onResize.add(@onResize)
		StageRenderer.onUpdate.add(@onUpdate)
		$('#chap01').click(@clickChap01)
		$('#chap02').click(@clickChap02)
		$('#chap03').click(@clickChap03)
		$('#chap04').click(@clickChap04)
		@isInit = true
		@onResize()

	@clickChap01:()->
		MainNavigation.onChapClick.dispatch(1)
		MainNavigation.setActiveChapter(1,true)
	@clickChap02:()->
		MainNavigation.onChapClick.dispatch(2)
		MainNavigation.setActiveChapter(2,true)
	@clickChap03:()->
		MainNavigation.onChapClick.dispatch(3)
		MainNavigation.setActiveChapter(3,true)
	@clickChap04:()->
		MainNavigation.onChapClick.dispatch(4)
		MainNavigation.setActiveChapter(4,true)
	@setActiveChapter:(num,animate)->
		console.log("MainNavigation.setActiveChapter."+num+"."+animate)
		margin = 128
		totalWidth = window.innerWidth
		inactiveWidth = 128
		activeWidth = totalWidth-margin*2-inactiveWidth*3

		chap01TargetWidth = if num==1 then activeWidth else inactiveWidth
		chap02TargetWidth = if num==2 then activeWidth else inactiveWidth
		chap03TargetWidth = if num==3 then activeWidth else inactiveWidth
		chap04TargetWidth = if num==4 then activeWidth else inactiveWidth

		###
		console.log(chap01TargetWidth)
		console.log(chap02TargetWidth)
		console.log(chap03TargetWidth)
		###
		d = 1
		if animate
			TweenLite.to("#chap01", 1, {width:chap01TargetWidth+"px"});
			TweenLite.to("#chap02", 1, {width:chap02TargetWidth+"px"});
			TweenLite.to("#chap03", 1, {width:chap03TargetWidth+"px"});
			TweenLite.to("#chap04", 1, {width:chap04TargetWidth+"px"});
		else
			$("#chap01").width(chap01TargetWidth+"px")
			$("#chap02").width(chap02TargetWidth+"px")
			$("#chap03").width(chap03TargetWidth+"px")
			$("#chap04").width(chap04TargetWidth+"px")

		return

	@onResize:()->
		console.log("MainNavigation.onResize")
		width 	= window.innerWidth
		height 	= window.innerHeight
		
		MainNavigation.setActiveChapter(1,false)
		#alert("@onResize")
	@onUpdate:()->
		return
module.exports = MainNavigation


/** WEBPACK FOOTER **
 ** ./src/coffee/modules/MainNavigation.coffee
 **/